/* One diagram of one version: drawn, being drawn, or still to draw (v3 `diagramPane`). */
.pane {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.frame {
  inline-size: 100%;
  min-block-size: 18rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
  background: var(--surface-2, transparent);
}

.legend,
.help {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-13);
}

/* v3 `.legend`: the journey's keys in one wrapping row. */
.legendList {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 0;
  padding: 0;
  list-style: none;
  color: var(--text-muted);
  font-size: var(--font-size-13);
}

.legendList li {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.state {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}

.title {
  margin: 0;
  font-size: 1rem;
}

.body {
  margin: 0;
  color: var(--text-muted);
}

.notice {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 10px 12px;
  border-radius: var(--radius-control);
  background: var(--danger-surface);
  color: var(--danger-text);
}

.notice p {
  margin: 0;
}

/* v3 `.spacer`: pushes "Volver a dibujar" to the end of the drawn bar. */
.spacer {
  flex: 1;
}

/* v3 `.legend` start key: the accent text colour, like the start screen's border. */
.legendStart {
  color: var(--action-text);
}
